export var Lang;

(function (Lang) {
  Lang["FR_FR"] = "fr_fr";
  Lang["ES_ES"] = "es_es";
  Lang["EN_GB"] = "en_gb";
  Lang["EN_US"] = "en_us";
  Lang["DE_DE"] = "de_de";
})(Lang || (Lang = {}));